import { render, staticRenderFns } from "./demo-crm-account-confirmation-flow.vue?vue&type=template&id=47e78ba2&scoped=true&"
import script from "./demo-crm-account-confirmation-flow.vue?vue&type=script&lang=js&"
export * from "./demo-crm-account-confirmation-flow.vue?vue&type=script&lang=js&"
import style0 from "./demo-crm-account-confirmation-flow.vue?vue&type=style&index=0&id=47e78ba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e78ba2",
  null
  
)

export default component.exports